import templateStr from 'text!./templates/binary-choice.html';

var controlId = 0;

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            titleLeft: '@',
            titleRight: '@',
            valueLeft: '=',
            valueRight: '=',
            model: '=',
            flavor: '@',
            isDisabled: '&'
        },
        controller: ['$scope', function ($scope) {
            $scope.controlId = 'binaryinputctrlx' + controlId++;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/BinaryChoice.js
// module id = 772
// module chunks = 0